import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyCSevSJVTAnPVcX0CfPFEqvNMOkNiXRLPs",
    authDomain: "i-strategies-lucas-cb.firebaseapp.com",
    databaseURL: "https://i-strategies-lucas-cb.firebaseio.com",
    projectId: "i-strategies-lucas-cb",
    storageBucket: "i-strategies-lucas-cb.appspot.com",
    messagingSenderId: "875954615340",
    appId: "1:875954615340:web:486e9bf2db9cfaf1"
};

// const configTwo = {
//     apiKey: "AIzaSyDiouG2j-rzdifCCp_1hM8PvWCmtYplkfk",
//     authDomain: "i-strategies-chatbot-embedded.firebaseapp.com",
//     databaseURL: "https://i-strategies-chatbot-embedded.firebaseio.com",
//     projectId: "i-strategies-chatbot-embedded",
//     storageBucket: "i-strategies-chatbot-embedded.appspot.com",
//     messagingSenderId: "335715341828",
//     appId: "1:335715341828:web:4e8947c822ae65b1"
// };

firebase.initializeApp(config);